import { render } from "./EmailRecipientsEditor.vue?vue&type=template&id=61d14b4c&ts=true"
import script from "./EmailRecipientsEditor.vue?vue&type=script&lang=ts"
export * from "./EmailRecipientsEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__